import React from 'react'

const CommentVisibilityNote: React.FC = () => (
  <p className="mb-4 italic">
    Please note: this is only visible to colleagues inside your firm. It is NOT
    visible to your referral partner or anyone outside of your firm.
  </p>
)

export default CommentVisibilityNote
